import { render, staticRenderFns } from "./Register_HeNan.vue?vue&type=template&id=468a75c3&scoped=true&"
import script from "./Register_HeNan.vue?vue&type=script&lang=js&"
export * from "./Register_HeNan.vue?vue&type=script&lang=js&"
import style0 from "./Register_HeNan.vue?vue&type=style&index=0&id=468a75c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a75c3",
  null
  
)

export default component.exports